class CustomProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".custom-gallery-wrapper--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.2,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1441: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-product-gallery", CustomProductGallery);

class CustomImageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });

      var swiper = new Swiper(
        ".slide-image-" + this.getAttribute("data-sectionid"),
        {
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          effect: "linear",
          spaceBetween: 40,
          slidesPerView: 3.5,
          loop: true,
          speed: 3000,
          breakpoints: {
            640: {
              slidesPerView: 3.5,
              spaceBetween: 40,
              loop: true,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 50,
              loop: true,
            },
            1024: {
              slidesPerView: 7,
              spaceBetween: 70,
              loop: true,
            },
            1441: {
              slidesPerView: 10,
              spaceBetween: 80,
              loop: true,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-image-slider", CustomImageSlider);

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      var galleryThumbs = new Swiper(".thumb-slider", {
        spaceBetween: 15,
        direction: "horizontal",
        slidesPerView: 5,
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 15,
            direction: "horizontal",
          },
          768: {
            slidesPerView: 7,
            spaceBetween: 15,
            direction: "horizontal",
          },
          1024: {
            slidesPerView: 8,
            spaceBetween: 12,
            direction: "vertical",
          },
          1441: {
            slidesPerView: 8,
            spaceBetween: 12,
            direction: "vertical",
          },
        },
      });

      var galleryTop = new Swiper(".main-slider", {
        spaceBetween: 15,
        direction: "horizontal",
        thumbs: {
          swiper: galleryThumbs,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
        },
      });

      document.addEventListener("repositionmainslider", (e) => {
        var index = e.detail.index;
        galleryTop.slideTo(index);
        galleryThumbs.slideTo(index);
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider", CustomSlider);

class CustomCollDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(document).ready(function () {
        $(".collection-des-content a[onclick]").addClass("collreadmore");
        $(".collection-des-content .collreadmore").removeAttr("onclick");
        $(".collection-des-content .collreadmore").click(function (e) {
          console.log("heuuu");
          var dots = $(".collection-des-content").find("#dots");
          var moreText = $(".collection-des-content").find("#more");
          var btnText = $(".collection-des-content").find("#myBtn");

          if (dots.is(":visible")) {
            dots.hide();
            moreText.show();
            btnText.text("Read Less");
          } else {
            dots.show();
            moreText.hide();
            btnText.text("Read More");
          }
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-coll-description", CustomCollDescription);

class MultiColumnSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });

      var swiper = new Swiper(
        ".multicolumnslider-" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 2,
          spaceBetween: 35,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 35,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
            1441: {
              slidesPerView: 7,
              spaceBetween: 60,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("multi-column-slider", MultiColumnSlider);

class CustomMainSearch extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var loadcomplete = false;
      var productcount = $(".total_no_of_products").text();

      var recentScroll = false;

      var product_on_page = $(".products-on-page");
      var next_url = product_on_page.data("next-url");
      var load_more__spinner = $(".load-more-container");

      console.log(
        "--announcement-bar-height==" + annheight + "px",
        "--header-height==" + headerheight + "px",
        "--collection-toolbar-height==" + colltoolheight + "px"
      );
      $("html").css({
        "--announcement-bar-height": annheight + "px",
        "--header-height": headerheight + "px",
        "--collection-toolbar-height": colltoolheight + "px",
      });

      $(window).on("scroll", function () {
        if (loadcomplete == false) {
          if (
            !recentScroll &&
            $(window).scrollTop() + $(window).height() >
              $(document).height() - 1900
          ) {
            if (productcount >= 28) {
              $.ajax({
                url: next_url,
                type: "GET",
                dataType: "html",
                beforeSend: function () {
                  load_more__spinner.show();
                },
              }).done(function (next_page) {
                load_more__spinner.hide();
                var new_products = $(next_page).find(".products-on-page");
                var new_url = new_products.data("next-url");

                if (new_url) {
                  next_url = new_url;
                  product_on_page.append(new_products.html());
                  var prnumb =
                    $(".products-on-page").find(".product-card").length;
                  loadcomplete = false;
                  console.log("false==" + prnumb);
                } else {
                  product_on_page.append(new_products.html());
                  var prnumb =
                    $(".products-on-page").find(".product-card").length;
                  loadcomplete = true;
                  console.log("true==" + prnumb);
                }
                var instock = "";
                var outstock = "";
                $("product-list product-card").each(function () {
                  if ($(this).data("stock") == true) {
                    instock =
                      instock + $("<div>").append($(this).clone()).html();
                  } else if ($(this).data("stock") == false) {
                    outstock =
                      outstock + $("<div>").append($(this).clone()).html();
                  }
                });
                var allhtml = instock + outstock;
                $("product-list").html(allhtml);
              });
            }

            recentScroll = true;
            window.setTimeout(() => {
              recentScroll = false;
              var annheight = $(".announcement-bar-height").data("height");
              var headerheight = $(".header-sticky-height").data("height");
              var colltoolheight = $(".collection-toolbar-height").data(
                "height"
              );

              console.log(
                "--announcement-bar-height==" + annheight + "px",
                "--header-height==" + headerheight + "px",
                "--collection-toolbar-height==" + colltoolheight + "px"
              );
              $("html").css({
                "--announcement-bar-height": annheight + "px",
                "--header-height": headerheight + "px",
                "--collection-toolbar-height": colltoolheight + "px",
              });
            }, 2001);
          }
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-main-search", CustomMainSearch);

class CustomGiftProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      function setCookie(cname, cvalue, exhours) {
        var d = new Date();
        d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function deleteCookie(cname) {
        var d = new Date();
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=;" + expires + ";path=/";
      }

      $(".addtocartcheckboxspecific").change(function () {
        if ($(this).is(":checked")) {
          $(".custom-specific-product-main").show();
        }
      });

      $(".addtocartcheckboxwhole").change(function () {
        if ($(this).is(":checked")) {
          $(".custom-specific-product-main").hide();
        }
      });

      if (getCookie("giftspecificproduct") == "true") {
        $(".custom-specific-product-main").show();
        $(".addtocartcheckboxspecific").prop("checked", true);
      } else {
        $(".custom-specific-product-main").hide();
        $(".addtocartcheckboxspecific").prop("checked", false);
      }

      $(".addtocartcheckbox").change(function () {
        if (this.checked) {
          var id = $(this).attr("data-pid");
          var data = {
            quantity: 1,
            id: id,
            properties: {
              "Wrapped Products": "Wrap entire order",
            },
          };
          $.ajax({
            url: "/cart/add.js",
            type: "POST",
            dataType: "json",
            data: data,
            success: function (data) {
              location.reload();
            },
          });
        } else {
          deleteCookie("giftwholesaleproduct");
          deleteCookie("giftspecificproduct");
          var id = $(this).attr("data-pid");
          $.ajax({
            url: "/cart/change.js",
            type: "POST",
            dataType: "json",
            data: {
              id: id,
              quantity: 0,
            },
            success: function (data) {
              location.reload();
            },
          });
        }
      });

      $(".updateproductproperties").on("click", function () {
        var variantIdToRemove = $(this).attr("data-pid");
        var wrapentireorder = $(".addtocartcheckboxwhole:checked").val();

        var updatedProperties = {};
        $(".giftproductproperty").each(function () {
          var propertyName = $(this).attr("name");
          var propertyValue = $(this).val().trim();
          updatedProperties[propertyName] = propertyValue;
        });

        function updatewrappedproduct() {
          var selectedwrappedproduct = [];
          $(".giftwrappedproduct:checked").each(function () {
            if ($(".addtocartcheckboxspecific").is(":checked")) {
              selectedwrappedproduct.push($(this).val());
            } else {
              selectedwrappedproduct.push();
            }
          });
          var selectedwrappedproductStr = selectedwrappedproduct.join(", ");
          return selectedwrappedproductStr;
        }

        var wrappedProductsStr = updatewrappedproduct();
        if ($(".addtocartcheckboxwhole").is(":checked")) {
          updatedProperties["Wrapped Products"] = wrapentireorder;
          setCookie("giftwholesaleproduct", "true", 24);
          deleteCookie("giftspecificproduct");
        } else {
          updatedProperties["Wrapped Products"] = wrappedProductsStr;
          setCookie("giftspecificproduct", "true", 24);
          deleteCookie("giftwholesaleproduct");
        }

        $.ajax({
          url: "/cart.js",
          type: "GET",
          dataType: "json",
          success: function (cart) {
            $(".updatetextbutton").hide();
            $(".load-more__spinner").show();
            var lineItemToRemove = cart.items.find(function (item) {
              return item.variant_id == variantIdToRemove;
            });

            if (lineItemToRemove) {
              var quantityToRemove = lineItemToRemove.quantity;
              var removeData = {
                updates: {},
              };
              removeData.updates[lineItemToRemove.key] = 0;
              $.ajax({
                url: "/cart/update.js",
                type: "POST",
                dataType: "json",
                data: removeData,
                success: function (updatedCart) {
                  var addData = {
                    quantity: quantityToRemove,
                    id: variantIdToRemove,
                    properties: updatedProperties,
                  };
                  $.ajax({
                    url: "/cart/add.js",
                    type: "POST",
                    dataType: "json",
                    data: addData,
                    success: function (updatedCart) {
                      location.reload();
                    },
                  });
                },
              });
            }
          },
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-gift-product", CustomGiftProduct);

class CustomSliderQuick extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var quickgalleryThumbs = new Swiper(".thumb-slider-quick", {
        spaceBetween: 15,
        slidesPerView: 5,
        breakpoints: {
          0: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 12,
          },
          1441: {
            slidesPerView: 6,
            spaceBetween: 12,
          },
        },
      });

      var quickgalleryTop = new Swiper(".main-slider-quick", {
        spaceBetween: 15,
        thumbs: {
          swiper: quickgalleryThumbs,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
      });

      document.addEventListener("repositionquickslider", (e) => {
        var index = e.detail.index;
        quickgalleryTop.slideTo(index);
        quickgalleryThumbs.slideTo(index);
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-slider-quick", CustomSliderQuick);

class CartGiftform extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".addtocartcheckbox").change(function () {
        if (this.checked) {
          var id = $(this).attr("data-pid");
          var data = {
            quantity: 1,
            id: id,
          };
          $.ajax({
            url: "/cart/add.js",
            type: "POST",
            dataType: "json",
            data: data,
            success: function (data) {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            },
          });
        } else {
          var id = $(this).attr("data-pid");
          $.ajax({
            url: "/cart/change.js",
            type: "POST",
            dataType: "json",
            data: {
              id: id,
              quantity: 0,
            },
            success: function (data) {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            },
          });
        }
      });

      $(".updateproductproperties").on("click", function () {
        var variantIdToRemove = $(this).attr("data-pid");
        var updatedProperties = {};
        $(".giftproductproperty").each(function () {
          var propertyName = $(this).attr("name");
          var propertyValue = $(this).val().trim();
          updatedProperties[propertyName] = propertyValue;
        });

        $.ajax({
          url: "/cart.js",
          type: "GET",
          dataType: "json",
          success: function (cart) {
            $(".updatetextbutton").hide();
            $(".load-more__spinner").show();
            var lineItemToRemove = cart.items.find(function (item) {
              return item.variant_id == variantIdToRemove;
            });

            if (lineItemToRemove) {
              var quantityToRemove = lineItemToRemove.quantity;
              var removeData = {
                updates: {},
              };
              removeData.updates[lineItemToRemove.key] = 0;
              $.ajax({
                url: "/cart/update.js",
                type: "POST",
                dataType: "json",
                data: removeData,
                success: function (updatedCart) {
                  var addData = {
                    quantity: quantityToRemove,
                    id: variantIdToRemove,
                    properties: updatedProperties,
                  };
                  $.ajax({
                    url: "/cart/add.js",
                    type: "POST",
                    dataType: "json",
                    data: addData,
                    success: function (updatedCart) {
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
                    },
                  });
                },
              });
            }
          },
        });
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("cart-gift-form", CartGiftform);

class CustomCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(document).ready(function () {
        $(".custom-code-content a[onclick]").addClass("collreadmore");
        $(".custom-code-content .collreadmore").removeAttr("onclick");
        $(".custom-code-content .collreadmore").click(function (e) {
          console.log("heuuu");
          var dots = $(".custom-code-content").find("#dots");
          var moreText = $(".custom-code-content").find("#more");
          var btnText = $(".custom-code-content").find("#myBtn");

          if (dots.is(":visible")) {
            dots.hide();
            moreText.show();
            btnText.text("Read Less");
          } else {
            dots.show();
            moreText.hide();
            btnText.text("Read More");
          }
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-code", CustomCode);

class CustomFooter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".linklist-heading").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show")) {
          $this.next().removeClass("show");
          $this.removeClass("show");
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find(".linklist-content").removeClass("show");
          $this.parent().parent().find(".linklist-content").slideUp(350);

          $this.next().toggleClass("show");
          $this.toggleClass("show");

          $this.next().slideToggle(350);
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-footer", CustomFooter);

class Customloyaltytable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".swiperothercol", {
        spaceBetween: 0,
        slidesPerView: 1,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1225: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1441: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-loyalty-table", Customloyaltytable);

class storetable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).find(".store-table-container").css({ opacity: "1" });

      var desktopview = $(this).data("desktopview");
      var tabperview = $(this).data("tabperview");
      var mobperview = $(this).data("mobperview");

      var swiper = new Swiper(".swiperothercol", {
        spaceBetween: 0,
        slidesPerView: mobperview,
        breakpoints: {
          0: {
            slidesPerView: mobperview,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: tabperview,
            spaceBetween: 0,
          },
          1441: {
            slidesPerView: desktopview,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("store-table", storetable);

class CustomLineItemQuantity extends HTMLElement {
  constructor() {
    super();
     $(".main-cart-container-stack").css("pointer-events", "auto");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

          $(".plus-custom")
      .unbind()
      .click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $(this).siblings(".item-qty-custom");
        console.log("plus==" + $input);
        var newQty = parseInt($input.val()) + 1;
        $input.val(newQty);
        var line = $(this).data("line");
        updateQuantity(line, newQty);
      });

    $(".minus-custom")
      .unbind()
      .click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $(this).siblings(".item-qty-custom");
        var minquantity = $(this).data("minquantity");
        var currentQty = parseInt($input.val());
        if (currentQty > 0) {
          var newQty = parseInt($input.val()) - 1;
          $input.val(newQty);
          var line = $(this).data("line");
          updateQuantity(line, newQty);
        }
      });

    $(document).on("click", ".cart__remove_product", function (e) {
      e.preventDefault();
      $(".main-cart-container-stack").css("pointer-events", "none");
      var line = $(this).data("line");
      var quantity = 0;
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
          line: line,
          quantity: parseInt(quantity),
        },
        dataType: "json",
        success: function (cart) {
          location.reload();
        },
        error: function (error) {
          $(".main-cart-container-stack").css("pointer-events", "auto");
        },
      });
    });

    function updateQuantity(line, quantity) {
      $(".main-cart-container-stack").css("pointer-events", "none");
      $.ajax({
        type: "POST",
        url: "/cart/change",
        data: {
          line: line,
          quantity: parseInt(quantity),
        },
        dataType: "json",
        success: function (cart) {
          location.reload();
        },
        error: function (error) {
          $(".main-cart-container-stack").css("pointer-events", "auto");
        },
      });
    }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-line-item-quantity", CustomLineItemQuantity);

    class CustomSliderFilter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');

        var filterslidercustom = new Swiper(".custom-main-filter-swiper", {
          spaceBetween: 20,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 20,
            },

            660: {
              slidesPerView:desktopperview - 2,
              spaceBetween: 20,
            },
            1025:{
              slidesPerView:desktopperview,
              spaceBetween: 20,
            },
            1441: {
              slidesPerView:desktopperview,
              spaceBetween: 20,
            }
          },
        });

        $(this).css({"opacity":"1"});
      };

      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: "0px 0px 300px 0px",
      });

      observer.observe(this);
    }
  }

  customElements.define("custom-slider-filter", CustomSliderFilter);

   $(document).ready(function(){
    $('.faq-view-more').unbind().click(function(){
      var lesstext = $(this).data('less');
      var moretext = $(this).data('more');
      var this2 = this;
      $('.hide-faq-accordion-wrapper').toggleClass('hide-faq-accordion');
      if (!$('.hide-faq-accordion-wrapper').hasClass('hide-faq-accordion')) {
        $(this2).text(lesstext);
      }else{
        $(this2).text(moretext);
      }
      
    });
  });
